// extracted by mini-css-extract-plugin
export default {"quilt__container":"styles_quilt__container__TpBDe"};